// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9s5U3","right":"styles_right__35_ib"};